<div class="row justify-content-center">
  <div class="col-lg-10">
      <div class="card">
          <div class="card-header bg-info">
              <h4 class="m-b-0 text-white">{{editingId ? 'Actualizar prueba' : 'Crear prueba personalizada'}}</h4>
          </div>
          <div class="card-body">

            <div>
              <div class="form-body">
                  <div class="row">
                    <div class="col-12">

                      <p><small><b>Puedes agrupar varias pruebas bajo un mismo grupo/categoría o visualizarlas individualmente. Si deseas agruparlas, ve al menú "Crear nuevo grupo" para organizar tus pruebas.</b></small></p>
                        <div class="form-group form-material">
                            <input [(ngModel)]="customTest.title" type="text" class="form-control" placeholder="Ponle el nombre al test/cuestionario">
                            <span class="help-block text-muted"><small>Título</small></span>
                        </div>
                    </div>



                    <div class="col-12 mb-5">

                      <div class="row">

                        <div class="col-12 mb-5">
                          <span >Descripción
                            <label class="mytooltip"><b class="text-info">?</b>
                              <span class="tooltip-content4">
                                Escribe el mensaje que verán los evaluados antes de comenzar el cuestionario. Aquí puedes dar instrucciones o información adicional.
                              </span>
                            </label>


                          </span>
                          <div id="toolbar">
                                    
                          </div>
                          <div class="description-editor">
                          </div>

                        </div>
                      </div>

                  

                      <!-- <div class="row justify-content-center">
                        <div *ngIf="editor" class="NgxEditor__Wrapper col-12 px-3">
                            <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                            <ngx-editor
                            [editor]="editor"
                            [(ngModel)]="editorHtml"
                            [placeholder]="'Escriba su texto...'"
                            ></ngx-editor>
                        </div>
                      </div> -->

                    </div>

                    <div class="col-12">
                      <div class="switch">
                        <label>
                          Preguntas aleatorias
                          <input [(ngModel)]="customTest.random" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                        </label>
                        <label class="mytooltip"><b class="text-info">?</b>
                          <span class="tooltip-content4">
                            Activa esta opción para cargar más preguntas de las necesarias. El sistema luego las seleccionará aleatoriamente para evitar repeticiones y hacer cada cuestionario único.                            
                          </span>
                        </label>
                      </div>

                    </div>

                    <div class="col-12" *ngIf="customTest.random">
                      <div class="form-group form-material">
                          <input [(ngModel)]="customTest.randomQty" type="number"  class="form-control" placeholder="Preguntas aleatorias">
                          <span class="help-block text-muted"><small>Cantidad de preguntas aleatorias</small></span>
                        </div>
                    </div>

                    <div class="col-12">
                      <div class="switch">
                        <label>
                          Mostrar timer
                          <input [(ngModel)]="customTest.timer" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                        </label>
                        <label class="mytooltip"><b class="text-info">?</b>
                          <span class="tooltip-content4">
                            Activa esta opción para establecer un tiempo límite para completar el cuestionario.
                          </span>
                        </label>
                      </div>
                    </div>

                    <div class="col-12" *ngIf="customTest.timer">
                      <div class="form-group form-material">
                          <input [(ngModel)]="customTest.timerQty" type="number"  class="form-control" placeholder="Minutos">
                          <span class="help-block text-muted"><small>Minutos límite del test</small></span>

                        </div>
                    </div>

                    <div class="col-12">
                      <div class="switch">
                        <label>
                          Activar sistema anti-trampas 
                          <input [(ngModel)]="customTest.secureTest" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                          El test se bloquea si el usuario cambia de pestaña o minimiza la ventana.
                        </label>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="switch">
                        <label>
                          Puede retroceder preguntas
                          <input [(ngModel)]="customTest.canGoBack" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                          Permite al evaluado retroceder y cambiar respuestas en el cuestionario.
                        </label>
                      </div>
                    </div>


                    <div class="col-12 mt-3">
                      <div class="form-group form-material">
                          <select [(ngModel)]="customTest.groupId" (ngModelChange)="setGroupName($event)" class="form-control custom-select">
                              <option value="">Ningun grupo</option>
                              <option *ngFor="let group of groups" [value]="group._id" >{{group.title}}</option>
                          </select>
                          <span class="help-block text-muted"><small>Grupo/Categoría</small>
                            <label class="mytooltip"><b class="text-info">?</b>
                              <span class="tooltip-content4">
                                Organiza tus test/cuestionarios en Grupos/Categorías para una mejor vista y gestión.
                              </span>
                            </label>
                          </span>

                      </div>
                    </div>
                    
                  </div>

                  <h3 class="card-title">Preguntas <button class="btn btn-info waves-effect btn-sm btn-rounded" data-target=".question-modal" data-toggle="modal" (click)="handleNewQuestion()" >Agregar pregunta</button></h3>
                  <hr>

                  <table *ngIf="customTest.questions && customTest.questions.length > 0" class="q-table tests-table table mt-3">
                    <tr>
                      <th>
                        <b>#</b>
                      </th>
                      <th>
                        <b>Pregunta</b>
                      </th>
                      <th>
                        <b>Acciones</b>
                      </th>
                      <th>
                        <b>Tipo</b>
                      </th>
                      <th>
                        <b>
                          Correcta/s
                        </b>
                      </th>
                      <th>
                        <b>
                          Explicación
                        </b>
                        <label class="mytooltip"><b class="text-white">?</b>
                          <span class="tooltip-content4">
                            El tilde indica que este ítem contiene el texto que se mostrará en la explicación de la respuesta correcta en el reporte (en caso que el evaluado responda incorrectamente).                            </span>
                        </label>
                      </th>
                      <th>
                        <b>Orden</b>
                      </th>
                    </tr>
                    <tr *ngFor="let q of customTest.questions; index as i">
                      <td>
                        {{i + 1}}
                      </td>
                      <td>
                        <span *ngIf="q.instructionsTimer && q.instructionsTimer > 0">
                          <svg  width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>                        
                        </span>
                        &nbsp;
                        {{getHtmlContent(q.question)}}
                      </td>
                      <td>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleEditQuestion(i)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDeleteQuestion(i)" ><i class="fa fa-eraser" ></i></button>
                      </td>
                      <td>
                        {{q.type | questionType}}
                      </td>
                      <td>
                        <span *ngFor="let a of q.answers; index as i">
                          <span *ngIf="a.correct" class="text-bold text-success">{{(i) | numberToLetter}} &nbsp;</span>
                        </span>                        
                      </td>
                      <td>
                        <span *ngIf="q.explanation.ops && q.explanation.ops.length > 1">
                          ✅
                        </span>
                      </td>
                      <td>
                        <button *ngIf="i > 0" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="moveArrayIndex(i, -1)" ><i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                        <button *ngIf="i == 0" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " ><i class="fa fa-minus" aria-hidden="true"></i></button>
                        <button *ngIf="i < customTest.questions.length - 1" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="moveArrayIndex(i, 1)" ><i class="fa fa-arrow-down" ></i></button>
                        <button *ngIf="i == customTest.questions.length - 1" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " ><i class="fa fa-minus" ></i></button>
                      </td>
                    </tr>
                  </table>

                  
              </div>
              <div class="form-actions">
                  <button type="button" class="btn btn-info btn-rounded mt-3" (click)="create()" > {{editingId ? 'Actualizar' : 'Guardar'}}</button>
              </div>
            </div>


          </div>
      </div>
  </div>
</div>


<div class="modal fade question-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" style="display: none;">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title" id="mySmallModalLabel">{{editingQuestionIndex > -1 ? 'Actualizar' : 'Agregar'}} pregunta</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          </div>
          <div class="modal-body">
              <div class="form-group ">

                <div class="col-12 mt-3">
                  <span ><b><b>Instrucciones (opcional)</b></b></span>
                  <div id="toolbar">
                            
                  </div>
                  <div class="instructions-editor">
                  </div>
                </div>

                <div class="col-12 mt-3">
                  <div class="form-group form-material">
                      <input [(ngModel)]="question.instructionsTimer" type="number"  class="form-control" placeholder="Tiempo de visualización de instrucciones (dejar cero para infinito)">
                      <span class="help-block text-muted"><small>Tiempo de visualización de instrucciones (dejar cero para infinito)</small></span>
                    </div>
                </div>

                  <div class="col-12 mt-3">
                    <span ><b><b>Pregunta</b></b></span>
                    <div id="toolbar">
                              
                    </div>
                    <div class="question-editor">
                    </div>
                  </div>

                  <div class="col-12 mt-3">
                    <div class="form-group form-material">
                        <input [(ngModel)]="question.questionTimer" type="number"  class="form-control" placeholder="Tiempo de visualización para pregunta y/o imagen estimulo (dejar cero para infinito)">
                        <span class="help-block text-muted"><small>Tiempo de visualización para pregunta y/o imagen estimulo (dejar cero para infinito)</small></span>
                      </div>
                  </div>





                  <div class="col-12">
                    <span >Explicación</span>
                    <div id="toolbar">
                              
                    </div>
                    <div class="explanation-editor">
                    </div>
                  </div>


                  <div class="col-12 mt-3">
                    <label class="control-label mt-3">Imágen estímulo(opcional)
                      <label class="mytooltip"><b class="text-info">?</b>
                        <span class="tooltip-content4">
                          Carga una imagen que se mostrará al evaluado en la pregunta. El evaluado deberá tomar acción o seleccionar una respuesta basada en la imagen.
                        </span>
                      </label>
                    </label>
                    <input type="file" hidden #imginput multiple="false" (change)="uploadImage($event)">
                    &nbsp;
                    <button class="btn-info btn btn-rounded btn-sm" (click)="imginput.click()">Subir imágen</button>
                    &nbsp;
                    <label class="mytooltip"><b class="text-info">?</b>
                      <span class="tooltip-content4">
                        Utilizar imágenes horizontales para obtener resultados, no usar imágenes verticales, ya que estas podrían mostrarse excesivamente grandes. 
                      </span>
                    </label>
                    <img class="q-img" *ngIf="question.questionImage" [src]="question.questionImage" alt="">
                  </div>


                  <div class="col-12 mt-3">
                    <label class="control-label mt-3">Imágen respuesta en reporte(opcional)
                      <label class="mytooltip"><b class="text-info">?</b>
                        <span class="tooltip-content4">
                          Carga una imagen que se mostrará en el reporte como referencia de la respuesta correcta, junto con la explicación textual.
                        </span>
                      </label>
                    </label>
                    <input type="file" hidden #imginput2 multiple="false" (change)="uploadImage($event, true)">
                    &nbsp;
                    <button class="btn-info btn btn-rounded btn-sm" (click)="imginput2.click()">Subir imágen</button>
                    &nbsp;
                    <label class="mytooltip"><b class="text-info">?</b>
                      <span class="tooltip-content4">
                        Utilizar imágenes horizontales para obtener resultados, no usar imágenes verticales, ya que estas podrían mostrarse excesivamente grandes. 
                      </span>
                    </label>
                    <img class="q-img" *ngIf="question.answerImage" [src]="question.answerImage" alt="">
                  </div>

                  <div class="col-12">
                    <div class="form-group form-material">
                        <select [(ngModel)]="question.type" class="form-control custom-select">
                            <option value="text">Texto</option>
                            <option value="number">Número</option>
                            <option value="multiple">Selección múltiple</option>
                            <option value="checkbox">Selección única</option>
                            <option value="conditional">Condicional</option>
                        </select>
                        <span class="help-block text-muted"><small>Tipo de pregunta (selecciona el tipo de pregunta que tomarás)</small></span>
                    </div>
                  </div>

                  <div *ngIf="question.type == 'conditional'" class="col-12 form-material">
                    <input [(ngModel)]="question.customPlaceholder" type="text"  class="form-control" placeholder="Próxima pregunta a responder según la respuesta seleccionada">
                    <span class="help-block text-muted"><small>Pregunta condicional</small></span>

                  </div>
                  <div *ngIf="question.type == 'conditional'" class="col-12">
                    <div class="switch">
                      <label>
                        ¿Puede modificar respuesta?
                        <input [(ngModel)]="question.canChangeAnswer" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                        (Al seleccionar una respuesta, no podrá seleccionar otra)
                      </label>
                    </div>
                  </div>

                  <div class="col-12 mt-3">
                    <div *ngIf="question.type != 'text'">
                      <h3 class="card-title">Opciones de respuesta </h3>
                      <hr>
  
                      <div class="row">
                        <div class="col-6 form-material">
                          <input [(ngModel)]="answer.title" type="text"  class="form-control" placeholder="Respuesta">
                          <span class="help-block text-muted"><small>Ingrese la opciones de respuesta que visualizará el evaluado</small></span>
  
                        </div>
  
                        <div class="col-3 pt-1">
                          <div class="switch">
                            <label>
                              Respuesta correcta
                              <input [(ngModel)]="answer.correct" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                            </label>
                          </div>
                          <div *ngIf="question.type == 'conditional'" class="switch">
                            <label>
                              Ingresar respuesta
                              <label class="mytooltip"><b class="text-info">?</b>
                                <span class="tooltip-content4">
                                  Habilita un campo de texto para escribir.
                                </span>
                              </label>
                              <input [(ngModel)]="answer.requestInput" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span>
                            </label>
                          </div>
                        </div>
  
                        <div class="col-3">
                          <button class="btn-info btn btn-rounded" (click)="addAnswer()">{{editingAnswerIndex > -1 ? 'Actualizar' : 'Agregar nueva'}}</button>
                          <button *ngIf="editingAnswerIndex > -1" type="button" class="btn btn-warning btn-rounded mt-3" (click)="handleNewAnswer()" > Cancelar</button>
  
                        </div>
  
                      </div>

                    </div>



                    <table *ngIf="question.answers.length > 0" class="q-table table tests-table mt-3">
                      <tr>
                        <th>
                          #
                        </th>
                        <th>
                          <b>Respuesta</b>
                        </th>
                        <th>
                          <b>Correcta</b>
                        </th>
                        <th>
                          <b>Acciones</b>
                        </th>
                      </tr>
                      <tr *ngFor="let a of question.answers; index as i">
                        <td>
                          {{(i) | numberToLetter}}
                        </td>
                        <td>
                          {{a.title}}
                        </td>
                        <td [ngClass]="a.correct ? 'text-bold text-success' : ''" >
                          {{a.correct ? 'SI' : 'NO'}}
                        </td>
                        <td>
                          <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleEditAnswer(i)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                          <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDeleteAnswer(i)" ><i class="fa fa-eraser" ></i></button>
                        </td>
                      </tr>
                    </table>

                    <button type="button" class="btn btn-info btn-rounded mt-3" (click)="addQuestion()" > {{editingQuestionIndex > -1 ? 'Actualizar' : 'Agregar'}} pregunta</button>


                  </div>
              </div> 
          </div>
      </div>
      <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>